import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import labService from './labService';
// Assuming you have a CSS file for this, or you can reuse Contact.css
import './css/Contact.css'; 

const RedeemCoupon = ({ isCollapsed, toggleSidebar }) => {
  const [code, setCode] = useState('');
  const [statusMsg, setStatusMsg] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  // Clear status messages after 10 seconds, just like the Contact page
  useEffect(() => {
    if (!statusMsg.text) return;

    const timer = setTimeout(() => {
        setStatusMsg({ type: '', text: '' });
    }, 10000);

    return () => clearTimeout(timer);
  }, [statusMsg]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
        const response = await labService.redeemCoupon(code);

        setStatusMsg({
            type: 'success',
            // Use the success message returned from our Django view
            text: response.data.message || 'Success! Added 5 tokens.' 
        });

        // Clear the input only on success
        setCode('');

    } catch (error) {
        setStatusMsg({
            type: 'error',
            // Grab the specific error message from Django, or use a fallback
            text: error.response?.data?.error || 'Error redeeming code. Please try again.'
        });
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className='lab-container'>
      <Navbar />
      <div className='lab-side-content'>
        {/* Make sure to adjust active_n to match wherever this page sits in your Sidebar */}
        <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        
        <div className='home-content'>
          <h2 className='aval-endp mar-usr-prof'>Redeem Code</h2>
          <p className='complete mar-usr-prof'>
            Enter a valid, single-use promotional code to add 5 tokens to your account.
          </p>

          <form onSubmit={handleSubmit} className='form-contact'>
            <div>
              <input 
                type="text"
                required
                className="inp-contact-email" // Reusing your input class for consistency
                placeholder="Enter code (e.g., XJ9-L2P)"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())} // Auto-capitalize
              />
            </div>

            <button 
              type="submit" 
              className="contact-send" 
              disabled={loading || !code.trim()}
            >
              {loading ? 'Redeeming...' : 'Redeem'}
            </button>

            {statusMsg.text && (
                <p
                    style={{
                        marginTop: '16px',
                        fontSize: '26px',
                        textAlign: 'center',
                        color: statusMsg.type === 'success' ? '#1e8834' : '#bd5656'
                    }}
                >
                    {statusMsg.text}
                </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default RedeemCoupon;